import * as types from './mutations-types'
import {DOWNLOAD_FILE} from '../../../../../common/utils/uploadFileUtil'

export default {
  [types.SHOPPING_CART_LIST] (state, data) {
    console.log(data)
    let codeToFileIds = data
    if (codeToFileIds) {
      codeToFileIds.filter((item, index) => {
        let imgList = []
        if (item.codeToFileIds && item.codeToFileIds.carousel) {
          item.codeToFileIds.carousel.filter((itemTwo, indexTwo) => {
            let img = `${DOWNLOAD_FILE}${itemTwo}?X-Authorization=${localStorage.getItem('token')}`
            imgList.push(img)
          })
        }
        item.codeToFileIds.carousel = imgList
        item.checked = false
      })
    }
    console.log(data)
    state.shoppingCartList = data
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/shoppting-cart/store/mutations.js